import React from 'react';
import PropType from 'prop-types';
import { Link, graphql } from 'gatsby';
import Img from 'gatsby-image';
import sal from 'sal.js';

import randomColorForImage from '~/utils/randomColorForImage';

import Layout from '~/layouts/header-footer';

import './home.scss';

import SEO from '~/components/seo';

class IndexPage extends React.Component {
  componentDidMount() {
    sal({
      threshold: 0.1,
    });
  }

  render() {
    const { data } = this.props;

    return pug`
      Layout
        SEO(title="Home")
        .index
          .hero-golden
            .hero-golden__left
              h1.large-title(data-sal="text-animation") Hum...
                br
                | hello?
            .hero-golden__right(data-sal="slide-up")
              Img(fluid=data.stefano.fluid, backgroundColor=randomColorForImage())
          .centered-container
            .big-body
              section
                p I’m Stefano, glad to see you here!
                  br
                  | A thing or two about me...
                p I personally dislike:
                ul
                  li(data-sal="text-animation") Labels, roles, titles.
                  li(data-sal="text-animation") Borders, barriers, bounds.
                  li(data-sal="text-animation") And raccoons, bloody raccoons
                    sup
                      a#ref1(href="#fn1") 1
                    | . 🦝
              section
                p I’m driven by:
                ul
                  li(data-sal="text-animation") Change, learn, exchange.
                  li(data-sal="text-animation") Create, mix, iterate.
                  li(data-sal="text-animation") Experiment, test, re&#8209;invent.
                p I’m a&nbsp;
                  a(href="https://puttylike.com/terminology/", target="_blank", rel="noopener") multipotentialite
                  | .
              section
                p I used to be a
                  sup.yellow
                    a#ref2(href="#fn2") 2
                  | :
                ul
                  li(data-sal="text-animation") Web Developer
                  li(data-sal="text-animation") Web Designer
                  li(data-sal="text-animation") iOS Developer
                  li(data-sal="text-animation") UI Designer
                  li(data-sal="text-animation") UX Designer
                  li(data-sal="text-animation") Entrepreneur
                  li(data-sal="text-animation") Product Owner
                  li(data-sal="text-animation") Digital Strategist
              section
                p.hidden-print
                  Link(to="/now") Now
                  | ?
                p I like to try/do/learn/play with
                  sup.red
                    a#ref3(href="#fn3") 3
                  | :
                ul
                  li(data-sal="text-animation") AI
                  li(data-sal="text-animation") Art
                  li(data-sal="text-animation") Code
                  li(data-sal="text-animation") Music
                  li(data-sal="text-animation") Colors
                  li(data-sal="text-animation") Design
                  li(data-sal="text-animation") Writing
                  li(data-sal="text-animation") Reading
                  li(data-sal="text-animation") Lifehacks
                  li(data-sal="text-animation") Traveling
                  li(data-sal="text-animation") Creativity
                  li(data-sal="text-animation") Philosophy
                  li(data-sal="text-animation") Psychology
                  li(data-sal="text-animation") Technology
                  li(data-sal="text-animation") Photography
                  li(data-sal="text-animation") Personal Growth
            .footnotes
              hr
              ul
                li
                  sup#fn1
                    a(href="#ref1") 1
                  small Just kidding! I love all the animals in the world, anyhow...have you ever met a feral raccoon? Just ask&nbsp;
                    a(href="https://www.youtube.com/watch?v=hHN-f6xTzsY", target="_blank", rel="noopener") Kevin Rose
                li
                  sup.yellow#fn2
                    a(href="#ref2") 2
                  small I no longer identify myself with roles. Also...list in arguably chronological order?
                li
                  sup.red#fn3
                    a(href="#ref3") 3
                  small List in a fancy word-length order
    `;
  }
}

IndexPage.propTypes = {
  data: PropType.object,
};

export default IndexPage;

export const query = graphql`
  query StefanoImageQuery {
    stefano: imageSharp(fixed: {originalName: {eq: "stefano.jpg"}}) {
      fluid(maxWidth: 700) {
        ...GatsbyImageSharpFluid
      }
    }
  }
`;
